<template>
  <div class="topGrey ">
    <b-container class="bv-example-row">
      <b-row>
        <b-col md="6">
          <div class="title flex_row_center">
            <img
              v-lazy="pictureBaseUrl + '/main/logo2.jpg'"
              alt
              class="title-logo"
            />
            <div class="title-word">浙江省工程师职称评审</div>
          </div></b-col
        >
        <b-col md="6">
          <div class="flex_row_around" style="height: 100%;">
            <div
              v-for="(item, index) in titleTab"
              :key="item.name"
              class="title-right-item"
              @mouseover="handleMouseOver(index)"
              @mouseleave="handleMouseLeave(index)"
            >
              <a class="title-right-item-a" @click="scrollTo(item)">
                {{ item.fouced ? item.enName : item.name }}</a
              >
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="my-modal" hide-footer title="职称评审资格测评">
      <ceping ref="childCe"></ceping>
      <div class="flex_row_between">
        <b-button
          class="mt-3"
          style="margin-right:10%;"
          variant="outline-danger"
          block
          @click="hideModal"
          >提交</b-button
        >
        <b-button
          class="mt-3"
          variant="outline-warning"
          block
          @click="toggleModal"
          >取消</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import ceping from "@/components/public/ceping";
var global = require("@/utils/global");

export default {
  name: "topGrey",
  components: { ceping },
  data() {
    return {
      msg: "topGrey",
      pictureBaseUrl: global.pictureBaseUrl,
      titleTab: [
        { name: "首页", enName: "HOME", fouced: false, link: "home" },
        { name: "服务流程", enName: "SERVICE", fouced: false, link: "service" },
        { name: "服务案例", enName: "CASES", fouced: false, link: "guarantee" },
        { name: "关于我们", enName: "ABOUT US", fouced: false, link: "about" },
      ],
    };
  },
  methods: {
    showModal() {
      this.$refs["my-modal"].show();
    },
    handleMouseOver(index) {
      this.titleTab[index].fouced = true;
    },
    handleMouseO(index) {
      this.titleTab[index].fouced = true;
    },
    handleMouseLeave(index) {
      this.titleTab[index].fouced = false;
    },
    hideModal() {
      let chil = this.$refs["childCe"];
      var changeData = chil.changeData;
      console.log(chil.changeData);
      //判断校验
      if (changeData.select1 == "") {
        this.$bvToast.toast("请选择工作地点", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }
      if (changeData.select2 == "") {
        this.$bvToast.toast("请选择学历情况", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }
      if (changeData.select3 == "") {
        this.$bvToast.toast("请选择已获证书", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }
      if (changeData.select4 == "") {
        this.$bvToast.toast("请选择工作年限", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }
      if (changeData.input1text == "") {
        this.$bvToast.toast("请输入毕业时间", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }
      if (changeData.input2text == "") {
        this.$bvToast.toast("请输入联系方式", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true,
        });
        return;
      }
      //提交接口发送 post 请求
      var form = [
        changeData.select1,
        changeData.select2,
        changeData.select3,
        changeData.select4,
        changeData.input1text,
        changeData.input2text,
      ];

      var form1 = {
        工作地点: changeData.select1,
        学历情况: changeData.select2,
        毕业时间: changeData.select3,
        已获证书: changeData.select4,
        工作年限: changeData.input1text,
        联系方式: changeData.input2text,
      };

      var formJsonStr = JSON.stringify(form1);

      var params = {
        title: formJsonStr,
        userId: 1,
      };
      this.$http
        .post("http://db.xxl-wind.com:9091/apiv1/formAdd", params, {
          emulateJSON: true,
        })
        .then(function(res) {
          this.$refs["my-modal"].hide();
        });
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    callQq() {
      window.open("tencent://message/?uin=1853041749");
    },
    scrollTo(item) {
      const section = document.getElementById(item.link);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.topGrey {
  font-size: 16px;
  font-weight: normal;
  font-family: 微软雅黑;
  color: #000000;
  text-shadow: none;
  background-color: #fff;
  padding: 5px 0px;
}

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1400px;
  }
}

.title {
  font-weight: 600;
  color: rgb(32, 38, 110);
  font-size: 36px;
  font-family: 微软雅黑, "Microsoft YaHei";
}
.title-right-item {
  text-align: center;
 
}
a {
  color: #333;
}

.title-right-item:hover {
  color: rgba(30, 80, 174, 1);
  border-bottom: 1px solid rgba(30, 80, 174, 1);
}
.main {
  padding: 20px;
}
.zixun {
  border: 1px solid #fff;
  text-align: center;
  width: 90%;
  margin-left: 5%;
}
.top-logo {
  height: 40px;
  width: 40px;
  margin-right: 6px;
}
.top-name {
  font-size: 20px;
  font-weight: 800;
}

a:hover {
  text-decoration: none;
  color: rgba(30, 80, 174, 1);
}

.shoujishipei {
  display: flex;
  justify-content: center;
}

.title-logo {
  width: 150px;
}

@media screen and (max-width: 780px) {
  .shoujishipei {
    display: flex;
    justify-content: flex-start;
  }

  .title-logo {
    width: 60px;
  }
  .title-word{
    font-size:24px
  }
}

/* .title-word{
  font-size:24px
} */
/* .title-word{
  background: linear-gradient(to right,#ffff00,#ff0000);
    -webkit-text-fill-color: transparent;
    background-clip: text;
} */
</style>



// WEBPACK FOOTER //
// src/components/public/top.vue